module.exports = __webpack_public_path__ + "img/login_pic.14d3e765.png";